import { i18n } from '@/iti-core-vue';
import { extend, ValidationProvider } from 'vee-validate';
import { email } from 'vee-validate/dist/rules';
import { Component, Prop } from 'vue-property-decorator';
import { ItiBaseEditor } from '../iti-base-editor';

@Component({
    components: {
        ValidationProvider,
    },
})
export default class ItiTextField extends ItiBaseEditor {
    @Prop() public type!: string;

    public created() {
        super.created();
        // Override the default message.        
        extend('email', {
            ...email,
            message: i18n.tc('rules.email')
        });
    }
}
